const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Remove+Shipping+Address+from+Profile+API


function removeShippingAddress(profileId, addressId) {
    let url = `/api/users/profiles/${profileId}/address/${addressId}`;
    return ufeApi.makeRequest(url, {
        method: 'DELETE'
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = removeShippingAddress;
